import { styled } from '@innowise-group/mui-kit';

export const Header = styled.div`
  ${({ theme }) => theme.fonts.primary[90]}
  color: ${({ theme }) => theme.palette.general.darkGrey[60]};
`;

export const Title = styled.div`
  ${({ theme }) => theme.fonts.primary[50]}
  margin-bottom: 10px;
  color: ${({ theme }) => theme.palette.general.darkGrey[80]};
`;

export const Description = styled.div`
  ${({ theme }) => theme.fonts.primary[50]}
  line-height: 22px;
  color: ${({ theme }) => theme.palette.general.darkGrey[80]};
`;
